export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/parser.worker.97e93df9.worker.js");
}
